import { CONTACT } from "@/lib/products";
import { MessageCircle } from "lucide-react";
import { trackWhatsAppClick } from "@/lib/analytics";

export default function WhatsAppBubble() {
  const msg = `Hi Shine on Coin! I would like to enquire about your personalized engravings.`;
  const href = `${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsAppClick({ placement: "floating_bubble" })}
      className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 flex items-center gap-2 md:gap-3 pulse-gold rounded-full p-3 md:pl-4 md:pr-5 md:py-3 bg-[#25D366] text-black shadow-[0_10px_40px_rgba(37,211,102,0.45)] hover:brightness-110 transition"
      data-testid="whatsapp-bubble"
      aria-label="Chat on WhatsApp"
    >
      <span className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-black/15 flex items-center justify-center">
        <MessageCircle size={18} />
      </span>
      <span className="hidden md:flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-widest-2 text-black/70">Chat with us</span>
        <span className="font-medium">WhatsApp</span>
      </span>
    </a>
  );
}
